import Message from '../message';

/**
 * Create the action
 */

const { thunk, request, success, error } = Message.index((data, fetch) => {
    // Prepare request
    let formData = [];
    ['target_id', 'target_type']
        .map(key => data[key] !== undefined ? formData.push(key + '=' + data[key]) : null);

    return fetch.get('/messages?' + formData.join('&'));
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
